import DocumentTitle from 'react-document-title';

import { ROUTE_TAG_CURRENT_NETWORK } from 'hb-react/publicoffice/constants/routeTags';
import PublicOfficeApp from 'hb-react/publicoffice/providers/App';
import useNetworkConfiguration from 'hb-react/publicoffice/utils/useNetworkConfiguration';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';
import GlobalStyle from 'hb-react/style/GlobalStyle';

import PasswordReset from './components/PasswordReset';

const PasswordResetApp = () => {
  const { networkConfiguration } = useNetworkConfiguration({
    styleNeeded: false,
    networkRouteTags: [
      {
        routeTag: ROUTE_TAG_CURRENT_NETWORK,
      },
    ],
  });

  if (networkConfiguration) {
    const { colors, theming, currentNetwork } = networkConfiguration;

    const customNetwork = {
      title: currentNetwork.title,
      colors: colors.colors,
      theming: theming.theming,
    };

    return (
      <PublicOfficeApp network={customNetwork}>
        <DocumentTitle
          title={generatePageTitle({
            title: __('Reset password'),
            networkName: customNetwork.title,
          })}
        />
        <GlobalStyle />
        <PasswordReset />
      </PublicOfficeApp>
    );
  }

  return null;
};

export default PasswordResetApp;
